/**
 * Servicio para gestión de envíos
 * Wrapper de DeliveryService con nomenclatura consistente
 */
import DeliveryService from '../../../services/delivery.service';

class EnviosService {
    /**
     * Obtiene listado de envíos con filtros
     * @param {Object} params - Parámetros de filtrado
     * @param {string} params.fechaInicio - Fecha inicio (ISO)
     * @param {string} params.fechaFin - Fecha fin (ISO)
     * @param {string} params.serieNumero - Serie-Número del albarán
     * @param {boolean} params.soloPendientes - Filtrar solo pendientes
     * @param {string} params.ejercicio - Año de ejercicio
     * @returns {Promise<Array>} Lista de envíos
     */
    static async list(params = {}) {
        const data = await DeliveryService.getEnvios(params);
        return Array.isArray(data) ? data : data?.data ?? [];
    }

    /**
     * Actualiza un envío (comentario o estado)
     * @param {Object} datos - Datos a actualizar
     * @param {string} datos.serie - Serie del albarán
     * @param {string} datos.albaran - Número del albarán
     * @param {string} datos.comentario - Comentario (opcional)
     * @param {string} datos.estado - Estado (opcional)
     * @param {string} datos.ejercicio - Año de ejercicio
     * @returns {Promise<any>} Resultado de la actualización
     */
    static async update(datos) {
        return await DeliveryService.updateEnvio(datos);
    }
}

export default EnviosService;
